export enum PaymentSources {
    Redepagos = 'Redepagos',
    BankTransfer = 'BankTransfer',
    Cash = 'Cash',
    Check = 'Check',
    Other = 'Other',
    Unknown = 'Unknown',
}
